import { addDays, addMinutes, min } from 'date-fns';
import { type Program, type ProgramWithingsOrderPostContentObjectList, type Topic, getMinContentDate } from 'models';
import { useMemo } from 'react';
import { getDatePickerDateType } from 'ui';
import type { WithingsOrderPostFormValues } from '../WithingsOrderPostForm';

type P = {
  objectData?: ProgramWithingsOrderPostContentObjectList;
  preSelectedProgramTopic?: Topic;
  program: Program;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
export const useGetWithingsOrderPostInitialValues = ({
  objectData,
  preSelectedProgramTopic,
  program,
}: P): Partial<WithingsOrderPostFormValues> =>
  useMemo(() => {
    const withingsOrderPost = objectData?.withings_order_post;
    const publishAt = objectData?.publishAt ?? addMinutes(getMinContentDate({ startTime: program.startTime }), 10);
    const todoDueDate = withingsOrderPost?.todoDueDate ?? min([addDays(publishAt, 1), program.endTime]);

    return {
      htmlContent: withingsOrderPost?.htmlContent ?? objectData?.htmlContent ?? undefined,
      programTopicId: objectData?.programsTopic.id ?? preSelectedProgramTopic?.id,
      publishAt: getDatePickerDateType(publishAt),
      textContent: withingsOrderPost?.textContent ?? objectData?.textContent,
      title: withingsOrderPost?.title,
      todoDueDate: getDatePickerDateType(todoDueDate),
    };
  }, [objectData, preSelectedProgramTopic, program]);
